/* eslint-disable security/detect-object-injection */
import { breakpoints } from './breakpoints';
var media = {
    up: function (breakpoint) {
        return "@media screen and (min-width: " + breakpoints[breakpoint].min + "px)";
    },
    down: function (breakpoint) {
        return "@media screen and (max-width: " + (breakpoints[breakpoint].min - 1) + "px)";
    },
    between: function (minBreakpoint, maxBreakpoint) {
        return "@media screen and (min-width: " + breakpoints[minBreakpoint].min + "px) and (max-width: " + (breakpoints[maxBreakpoint].min - 1) + "px)";
    },
};
export { media };
//# sourceMappingURL=media.js.map